import api from "../../../utils/api";
import {
  PLATFORM_BILLING_ENDPOINTS,
  type ConsumptionReport,
  type PlatformBillingOverview,
  type PlatformGapReport,
  type PlatformInvoice,
  type PlatformInvoiceData,
} from "@torre/expenses";

// ---------------------------------------------------------------------------
// Cliente API de «Pago de plataformas» (#956 / #957). Respuestas `{ meta, data }`.
// ---------------------------------------------------------------------------

const MULTIPART = { headers: { "Content-Type": "multipart/form-data" } };
const data = <T>(res: any): T => res?.data?.data as T;
const E = PLATFORM_BILLING_ENDPOINTS;

export interface PlatformBillingResponse {
  from: string;
  to: string;
  today: string;
  rates: Record<string, number>;
  overview: PlatformBillingOverview;
  gaps: PlatformGapReport[];
  consumption: ConsumptionReport[];
  pendingInvoices: number;
}

export type PlatformInvoiceRow = PlatformInvoice & {
  warning?: string | null;
  expense?: { id: string; date: string; amount: number; currency: string; amountBase: number | null; vendor: string } | null;
};

export interface ConfirmInvoicePayload {
  platformId: string;
  expenseId?: string | null;
  createExpense?: boolean;
  data?: Partial<Pick<PlatformInvoiceData, "vendor" | "invoiceNumber" | "issueDate" | "periodFrom" | "periodTo" | "total" | "currency" | "exchangeRate" | "seats" | "usageQuantity" | "usageUnit">>;
}

export const fetchPlatformBilling = async (params: { from?: string; to?: string } = {}) =>
  data<PlatformBillingResponse>(await api.get(E.billing, { params }));

export const fetchPlatformInvoices = async (params: { platformId?: string; status?: string } = {}) =>
  data<PlatformInvoiceRow[]>(await api.get(E.invoiceList, { params }));

export async function uploadPlatformInvoices(files: File[]) {
  const form = new FormData();
  files.forEach((f, i) => form.append(`file${i}`, f));
  return data<{ invoices: PlatformInvoiceRow[]; duplicates: { name: string; duplicateOf: string }[] }>(
    await api.post(E.invoiceUpload, form, { ...MULTIPART, timeout: 300_000 }),
  );
}

export const confirmPlatformInvoice = async (id: string, payload: ConfirmInvoicePayload) =>
  data<{ invoice: PlatformInvoiceRow }>(await api.put(E.invoiceConfirm, payload, { params: { id } }));

export const deletePlatformInvoice = async (id: string) => data(await api.delete(E.invoice, { params: { id } }));
